import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { CartTenders } from 'src/items-list/business-logic/service/interfaces/cart-response';

export const getCartTenders = async (transactionId: string): Promise<CartTenders> => {
  /*  tech debt story needed to clean this up.
      currently the bff does not include the wic object for the tenders 
      so an additional call was made here */
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/cart-tenders`,
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<CartTenders>(emeraldRequestParams);
};
